import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "children", "regular", "className", "style", "inline", "required", "id", "sectiontype"];
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import styles from './heading.module.scss';
var sizes = {
  1: styles.h1,
  2: styles.h2,
  3: styles.h3,
  4: styles.h4,
  5: styles.h5
};
var regularSizes = {
  1: styles.h1Regular,
  2: styles.h2Regular,
  3: styles.h3Regular,
  4: styles.h4Regular,
  5: styles.h5Regular
};
var getSizeAsClass = function getSizeAsClass(size, regular) {
  return regular ? regularSizes[size] : sizes[size];
};
var Heading = function Heading(props) {
  var size = props.size,
    children = props.children,
    regular = props.regular,
    className = props.className,
    style = props.style,
    inline = props.inline,
    required = props.required,
    id = props.id,
    sectiontype = props.sectiontype,
    rest = _objectWithoutProperties(props, _excluded);
  var totalClass = cx(getSizeAsClass(size, regular), className, _defineProperty({
    'd-inline': inline
  }, styles.requiredLabel, required));
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    sectiontype: sectiontype,
    style: style,
    className: totalClass,
    id: id
  }), children);
};
Heading.propTypes = {
  size: PropTypes.oneOf([1, 2, 3, 4, 5]),
  children: PropTypes.node,
  regular: PropTypes.bool,
  inline: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.object,
  sectiontype: PropTypes.string
};
Heading.defaultProps = {
  size: 1,
  children: undefined,
  regular: false,
  inline: false,
  required: false,
  className: EMPTY_STRING,
  id: EMPTY_STRING,
  style: EMPTY_OBJECT,
  sectiontype: EMPTY_STRING
};
export default Heading;